import React from 'react';
import { InvoiceRefundModal } from 'components/invoiceRefund/InvoiceRefundModal';
import { orderRefundAdapter } from 'components/invoiceRefund/adapters/orderAdapter';
import { InvoiceModel } from 'lib/model/objects/invoiceModel';
import { OrderInvoice, PaymentGateway } from 'lib/types/invoices';
import { OrderModel } from 'lib/model/objects/orderModel';
import { useHasPermission } from 'utils/useHasPermission';
import { Permissions } from 'lib/permissions/roles';
import { NewspaperOrderModel } from 'lib/model/objects/newspaperOrderModel';

interface OrderRefundInvoiceModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  onError?: () => void;
  order: OrderModel;
  invoice: InvoiceModel<OrderInvoice>;
  newspaperOrders?: NewspaperOrderModel[];
  adTitle?: string;
}

export function OrderRefundInvoiceModal({
  open,
  onClose,
  onSuccess,
  onError,
  order,
  invoice,
  newspaperOrders,
  adTitle
}: OrderRefundInvoiceModalProps) {
  const canVoid = useHasPermission(Permissions.INVOICES_VOID);
  const canRefund = useHasPermission(Permissions.INVOICES_REFUND);

  if (!open) return null;

  return (
    <InvoiceRefundModal
      adapter={orderRefundAdapter}
      entity={{
        kind: 'order',
        id: order.id,
        title: adTitle || null,
        timezone: 'America/New_York',
        currency: 'USD',
        gateway: PaymentGateway.STRIPE,
        newspaperOrders: newspaperOrders?.map(no => ({
          id: no.id,
          // We don't have the newspaper snapshot here and avoid async fetches; label generically
          newspaperName: 'Publisher',
          publishingDates: no.modelData.publishingDates,
          publishingMedium: no.modelData.publishingMedium,
          pricingTotalInCents: no.modelData.pricing?.totalInCents ?? 0,
          totalRefundInCents: no.modelData.pricing?.totalRefundedInCents ?? 0
        }))
      }}
      invoice={invoice}
      permissions={{ canVoid, canRefund }}
      onClose={onClose}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
}
